import { useSelector } from "react-redux";
import { EditListIcon, EditPrintIcon } from "../../../../assets/images/svg/svg";
import {
  editModal,
  openModal,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import { setWhiteListedEdit } from "../../../../slices/IpSettings/ipSettingsSlice";
import rootReducer from "../../../../store";
import { checkButtonAccess, renderStatus } from "../../../../Utils/CommonUtils";
import { readIpSettingsbyId } from "../IpSettingsService";
import { useState } from "react";

const useIpSettingsColumn = (handleIpSettingModalOpen) => {
  const [showEditBtn, setEditBtn] = useState(
    checkButtonAccess("EDIT", "SETN_IPWL")
  );

  const IpSettingsColumns = [
    {
      header: "IP Address",
      accessorKey: "ip_address",
      cell: (props) => (props?.getValue() ? props.getValue() : "-"),
      size: 250,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 250,
    },

    {
      header: "Mapped User",
      accessorKey: "user_count",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),

      size: 300,
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (props) => {
        const statusValue = props.getValue();
        return (
          <div className="edit-modal">
            <span>{statusValue ? renderStatus(props?.getValue()) : "-"}</span>
          </div>
        );
      },
      size: 150,
    },
    {
      header: "Action",
      accessorKey: "",
      cell: (props) =>
        showEditBtn ? (
          <>
            <div
              // onClick={() => handleIpSettingModalOpen(props.row.entityid)}
              onClick={() => {
                rootReducer.dispatch(openModal(true));
                rootReducer.dispatch(editModal(true));
                // rootReducer.dispatch(updateRendererFormState(props?.row?.original));
                rootReducer.dispatch(
                  setWhiteListedEdit(props?.row?.original?.entityid)
                );
              }}
            >
              <EditListIcon />
            </div>
          </>
        ) : (
          ""
        ),
      size: 50,
    },
  ];

  return { IpSettingsColumns };
};

export default useIpSettingsColumn;
